import { useSyncExternalStore } from "react";
import {
  getAnalyticsConsent,
  setAnalyticsConsent,
  subscribeAnalyticsConsent,
} from "@repo/shared/analyticsConsent";

import { Switch } from "../ui/switch";
import { SettingsRow } from "./settingsLayout";
import { searchableSetting } from "./settingsSearch";

/**
 * The one place to change the analytics answer after the first-run prompt.
 * Backed by the same consent store the prompt writes, so PostHog and Sentry
 * react immediately in both directions.
 */
export function AnalyticsPrivacyRow() {
  const consent = useSyncExternalStore(
    subscribeAnalyticsConsent,
    getAnalyticsConsent,
    getAnalyticsConsent,
  );
  return (
    <SettingsRow
      {...searchableSetting("analytics-consent")}
      description={
        <>
          Optional product analytics and masked session recordings help us understand product use.
          Essential sign-in and security features work either way.{" "}
          <a
            className="text-foreground underline underline-offset-4 transition-colors hover:text-primary"
            href="https://www.amoreg.com/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy policy
          </a>
        </>
      }
      control={
        <Switch
          aria-label="Share product analytics"
          checked={consent === "accepted"}
          onCheckedChange={(accepted) => setAnalyticsConsent(accepted)}
        />
      }
    />
  );
}
